import { render, staticRenderFns } from "./diyDrawer.vue?vue&type=template&id=13b4ec5c&scoped=true"
import script from "./diyDrawer.vue?vue&type=script&lang=js"
export * from "./diyDrawer.vue?vue&type=script&lang=js"
import style0 from "./diyDrawer.vue?vue&type=style&index=0&id=13b4ec5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b4ec5c",
  null
  
)

export default component.exports